import type { Rung } from "../api/client";

/** The trust rung: a badge and a label, never a number (Build spec, Design direction). */
export function RungBadge({ rung }: { rung: Rung }) {
  const steps = ["self_claimed", "peer_vouched", "affiliated", "organisation_confirmed", "anchored"];
  const level = steps.indexOf(rung.id);
  return (
    <span className={`rung ${rung.id}`} data-testid="rung" data-rung={rung.id}>
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
        {rung.id === "anchored"
          ? <path d="M9 1.5 16.5 9 9 16.5 1.5 9Z" fill="currentColor" />
          : [0, 1, 2, 3].map((i) => <rect key={i} x={1 + i * 4.3} y={13 - i * 3.5} width="3" height={4 + i * 3.5} rx="1"
              fill="currentColor" opacity={i < level ? 1 : 0.25} />)}
      </svg>
      {rung.label}
    </span>
  );
}
